import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard')({
  component: RouteComponent,
  loader: () => ({
    crumb: 'Dashboard',
  }),
});

function RouteComponent() {
  return <div>Hello "/_dashboard/"!</div>;
}
